import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Link } from "react-router-dom";
import Marquee from "react-fast-marquee";
import Menu from "./Menu";
import Booking from "./Booking";
import Slider from "./Slider";
import Dataentry from "./Dataentry";
import SiteFooter from "./SiteFooter";
import axios from 'axios';
import Live from './Live';
import Popup from './Popup';
import Rightside from './Rightside';
import LatestNews from "./LatestNews";
import BookingCarousel from './BookingCarousel';
import InfoGraphic from './InfoGraphic';
import Timeline from './Timeline';

import { useTranslation } from "react-i18next";
import LanguageSelector from './LanguageSelector';

// const API_BASE = "http://localhost/myapp/api/uploads";

const API_BASE = "https://spst.in/myapp/api/uploads";

function Home() {

	const [uploads, setUploads] = useState([]);
	const [editId, setEditId] = useState(null);
	const [editName, setEditName] = useState('');

	useEffect(() => {
		fetchUploads();
	}, []);

	const fetchUploads = async () => {
		const res = await axios.get(`${API_BASE}/get.php`);
		setUploads(res.data);
	};

	const handleDelete = async (id) => {
		if (!window.confirm("Delete this record?")) return;
		await axios.post(`${API_BASE}/delete.php`, { id });
		fetchUploads();
	};

	const startEdit = (item) => {
		setEditId(item.id);
		setEditName(item.name);
	};

	const saveEdit = async () => {
		await axios.post(`${API_BASE}/update.php`, { id: editId, name: editName });
		setEditId(null);
		fetchUploads();

		
	};

 const { t } = useTranslation();


	return (
		<div>
	

			{/* <Popup /> */}

			<Slider />
			<div className="container">
				{/* <Booking /> */}
				<BookingCarousel />
			</div>
		
		
			{/* <div className="container" style={{display:'flex',width:'100%',marginBottom:'25px'}}>
			<div className="col-md-2" style={{background:'orange',color:'maroon',display:'flex',alignItems:'center',justifyContent:'center',borderRadius:'0px 0px 15px 15px'}}>
				<h4 style={{fontWeight:'600',color:'maroon'}}>Latest Updates</h4>
			</div>
			<div className="col-md-10" style={{background:'maroon',padding:'5px',borderRadius:'0px 0px 15px 15px',display:'flex',alignItems:'middle'}}>
				<Marquee speed={50} gradient={false} pauseOnHover>
					<div class="news_post_title" style={{padding:'0px'}}><p style={{color:'white',fontSize:'12pt'}}>For enquiries and booking, Contact at +91 471 246 6830</p></div>
				</Marquee>
			</div>
	  </div> */}


			{/* <div className="row">
				<LatestNews />
			</div> */}

			<div className="row">
		
				<div className="col-12 col-md-8" style={{ marginBottom: '50px' }}>

					{/* <p className="about" >
						ത്രേതായുഗത്തിൽ വനവാസകാലത്ത് യാത്രാമദ്ധ്യേ ശ്രീ അയ്യപ്പ ക്ഷേത്രത്തിൽ ആഗതനായ ഭഗവാൻ ശ്രീരാമചന്ദ്രൻ ഇവിടെ സുബ്രഹ്മണ്യ സാന്നിദ്ധ്വം അനുഭവപ്പെട്ടതിനാൽ സുബ്രഹ്മണ്യ പ്രതിഷ്ഠ നടത്തുന്നതിനായി സന്തത സഹചാരിയായ ശ്രീ ഹനുമാൻ സ്വാമിയോടു സുബ്രഹ്മണവിഗ്രഹം കൊണ്ടുവരുവാൻ നിർദ്ദേശിക്കുകയും മുഹൂർത്ത സമയത്ത് വിഗ്രഹം എത്താതിരുന്നതിനാൽ മുഹൂർത്തം തെറ്റാതിരിക്കാൻ ശ്രീരാമൻ തന്റെ കൈയ്യിലെ പെരുവളയൂരിയെടുത്തു പ്രതിഷ്ഠിക്കുകയും പെരുവള പ്രതി ഷ്ഠിക്കപ്പെട്ട ക്ഷേത്രവും, പ്രദേശവും പെരുവളശ്ശേരി എന്നും, കാലാന്തരത്തിൽ പെരളശ്ശേരിയായി പ്രസിദ്ധി നേടുകയും ചെയ്തു.
പൗരാണികവും കേരളവാസ്തു ശിൽപ്പചാരുത വിളിച്ചോതുന്നതുമായ മനോഹരമായ തീർത്ഥക്കുളം ഭക്തജനങ്ങളെ ഹഠാദാകർഷിക്കുകയും ആയത് ക്ഷേത്രത്തിന്റെ മാത്രം പ്രത്യേകതയായി നിലനിൽക്കുകയും ചെയ്തു വരുന്നു. കേരളത്തിലെ നാഗാരാധന നടക്കുന്ന പ്രധാന ക്ഷേത്രങ്ങളിലൊന്നാണ് ശ്രീ പെരളശ്ശേരി ക്ഷേത്രം.
					</p> */}
					<div className="">
						<div className="row">
							<div className="col-md-12">
								<div className="frame">
									<div className="row frame-1">
										<div className="col-md-6" style={{ backgroundImage: 'url(./images/9.jpg)', backgroundSize: 'cover', backgroundPosition: 'center',height:'65vh' }}>
											{/* <div className="leftimage">
												<img src="./images/about-left.jpg" />
											</div> */}
										</div>
										<div className="col-md-6">
											<div className="frontbox">
												{/* <p className="historyheadeg">ഐതിഹ്യം</p> */}
												<p className="frame-1-p">
													 {t("first para")}
												</p>

												{/* <Link to="/Ithihyam" className="btn btn-warning pos">Read More</Link> */}
											</div>
										</div>
									</div>
								</div>
							</div>
							{/* <div className="col-md-12">
								<div className="frame">
									<div className="row frame-1">
										<div className="col-md-3">
											<div className="leftimage">
												<img src="./images/ram.png" />
											</div>
										</div>
										<div className="col-md-9">
											<div>
												<p className="historyheadeg">ശ്രീ മക്രേരി ക്ഷേത്രവും ജീർണ്ണോദ്ധാരണ പ്രവർത്തനങ്ങളും</p>
												<p className="frame-1-p">
													ആർഷ ഭാരത സംസ്‌കാരത്തിൻ്റെ ഭാഗമായി ലോകനന്മയെ മുൻനിർത്തി ക്കൊണ്ടും ജനങ്ങളുടെ ഭാവിശ്രേയസ്സിന്നുതകുമാറും ഋഷീശ്വരന്മാരും അവതാര പുരുഷന്മാരും ദേവതാരാധനയ്ക്കനുയോജ്യമായ നിരവധി ദേവാലയങ്ങൾ ഭാരത ത്തിലെങ്ങും സ്ഥാപിച്ചിട്ടുണ്ട്.
												</p>
												<Link to="/Activities" className="btn btn-warning pos">Read More</Link>
											</div>
										</div>
									</div>
								</div>
							</div>
							<div className="col-md-12">
								<div className="frame">
									<div className="row frame-1">
										<div className="col-md-3">
											<div className="leftimage">
												<img src="./images/ram.png" />
											</div>
										</div>
										<div className="col-md-9">
											<div>
												<p className="historyheadeg">സുബ്രഹ്മണ്യ സങ്കല്പ്‌പം</p>
												<p className="frame-1-p">
													സ്ക‌ന്ദപുരാണത്തിൽ സുബ്രഹ്മണ്യ ഉൽപ്പത്തിയെപ്പറ്റി പ്രതിപാദിക്കുന്നുണ്ട്. താരകാസുരവധത്തിനായി ദേവസേനാനിയായി സുബ്രഹ്മണ്യൻ ശിവപുത്രനായി പിറന്നു.
												</p>
												<Link to="/Imagination" className="btn btn-warning pos">Read More</Link>
											</div>
										</div>
									</div>
								</div>
							</div>  */}
						</div>
					</div>

				</div>
				<div className="col-12 col-md-4" style={{ backgroundImage: 'url(./images/slider-2.jpg)', padding: '5px', backgroundSize: 'cover', backgroundPosition: 'center', backgroundAttachment: 'fixed' }}>
					<div class="booking-container">

						{/* <!-- SINGLE DAY --> */}
						<div class="booking-box single">
							<div class="icon">
								<img src="https://cdn-icons-png.flaticon.com/512/2972/2972357.png" alt="Single Day Pooja Booking" />
							</div>
							{/* <h3 className="books-3-ways">Single Day Pooja</h3>
					<p>Book pooja for a specific auspicious day with full temple rituals.</p>
					<div class="infobar">
						<span></span>
					</div> */}
							<div class="book-btn">
								<a href="#">
									Single Day Pooja <span>➜</span>
								</a>
							</div>

						</div>

						{/* <!-- MULTIPLE DAY --> */}
						<div class="booking-box multiple">
							<div class="icon">
								<img src="https://cdn-icons-png.flaticon.com/512/3652/3652191.png" alt="Multi dy Pooja Booking" />
							</div>
							{/* <h3 className="books-3-ways">Multiple Day Pooja</h3>
					<p>Schedule pooja services for several days or festivals.</p>
					<div class="infobar">
						<span></span>
					</div> */}
							<div class="book-btn">
								<a href="#">
									Multiple Day Pooja <span>➜</span>
								</a>
							</div>

						</div>

						{/* <!-- E-KANIKKA --> */}
						<div class="booking-box ekanikka">
							<div class="icon">
								<img src="https://cdn-icons-png.flaticon.com/512/2331/2331944.png" alt="e-kanikka" />
							</div>
							{/* <h3 className="books-3-ways">E-Kanikka</h3>
					<p>Offer digital donations securely to the deity from anywhere.</p>
					<div class="infobar">
						<span></span>
					</div> */}
							<div class="book-btn">
								<a href="#">
									E-Kanikka <span>➜</span>
								</a>
							</div>

						</div>

					</div>
				</div>
			</div>
			<div className="row" style={{ backgroundImage: 'url(./images/slider-2.jpg)', backgroundSize: 'cover', backgroundPosition: 'center',backgroundAttachment:'fixed' }}>
				<div style={{ background: 'rgba(29, 0, 0, 0.6)' }}>
					<h1 style={{color:'white',background:'maroon',borderBottom:'1px solid white',padding:'25px',fontFamily:'anek malayalam',fontSize:'22pt'}}> 
						{t("Important Vazhipads")}</h1>
					<Timeline />
				</div>
			</div>
		</div>

	);
}

export default Home;